<template>
    <aside class="right-side md:ml-64 bg-gray-200 p-5 h-full flex flex-col">
        <!-- Content Header (Page header) -->
        <section 
            class="bg-white px-5 py-3 mb-5 -mx-5 -mt-5 shadow z-20"
        >
            <h1 class="uppercase tracking-wider">{{this.$store.state.page_title?this.$store.state.page_title:this.$route.meta.title}}</h1>
        </section>
        <!-- Main content -->
        
        <slot></slot>
        <!--rightside bar -->
        <!--<right-side-bar></right-side-bar>-->
        <!-- /.content -->
    </aside>
</template>
<script>

import rightSideBar from './right-side-bar'

export default {
    name: 'right-side',

    components: {
        rightSideBar,
    }
}
</script>
